import {
  SelectElvarliVariantSheet,
  SELECT_ELVARLI_VARIANT,
} from './SelectElvarliVariantSheet/SelectElvarliVariantSheet';
import { WhatsIncludedSheet, WHATS_INCLUDED } from './WhatsIncludedSheet';
import { AdditionalInfoSheet, ADDITIONAL_INFO } from './AdditionalInfoSheet';
import {
  CombinedProductsSheet,
  COMBINED_PRODUCT_INFO,
} from './CombinedProductsSheet';
import React from 'react';

export const SheetKeys = {
  SELECT_ELVARLI_VARIANT,
  WHATS_INCLUDED,
  ADDITIONAL_INFO,
  COMBINED_PRODUCT_INFO,
};

type SheetComponents = {
  [key: string]: React.FunctionComponent<any>;
};

const sheetComponents: SheetComponents = {
  [SELECT_ELVARLI_VARIANT]: SelectElvarliVariantSheet,
  [WHATS_INCLUDED]: WhatsIncludedSheet,
  [ADDITIONAL_INFO]: AdditionalInfoSheet,
  [COMBINED_PRODUCT_INFO]: CombinedProductsSheet,
};

export default sheetComponents;
